export const INDIAN_CITIES = [
  "Mumbai",
  "Kolkāta",
  "Bangalore",
  "Chennai",
  "Hyderābād",
  "Pune",
  "Ahmedabad",
  "Sūrat",
  "Prayagraj",
  "Lucknow",
  "Jaipur",
  "Cawnpore",
  "Mirzāpur",
  "Nāgpur",
  "Ghāziābād",
  "Vadodara",
  "Vishākhapatnam",
  "Indore",
  "Thāne",
  "Bhopāl",
  "Chinchvad",
  "Patna",
  "Bilāspur",
  "Ludhiāna",
  "Agwār",
  "Āgra",
  "Madurai",
  "Jamshedpur",
  "Nāsik",
  "Farīdābād",
  "Aurangābād",
  "Rājkot",
  "Meerut",
  "Jabalpur",
  "Kalamboli",
  "Vasai",
  "Najafgarh",
  "Vārānasi",
  "Srīnagar",
  "Dhanbād",
  "Amritsar",
  "Alīgarh",
  "Guwāhāti",
  "Hāora",
  "Rānchi",
  "Gwalior",
  "Chandīgarh",
  "Vijayavāda",
  "Jodhpur",
  "Raipur",
  "Kota",
  "Kālkāji Devi",
  "Bhayandar",
  "Ambattūr",
  "Salt Lake City",
  "Bhātpāra",
  "Kūkatpalli",
  "Darbhanga",
  "Dāsarhalli",
  "Muzaffarpur",
  "Oulgaret",
  "New Delhi",
  "Tiruvottiyūr",
  "Puducherry",
  "Byatarayanpur",
  "Pallāvaram",
  "Secunderābād",
  "Shimla",
  "Puri",
  "Shrīrāmpur",
  "Hugli",
  "Chandannagar",
  "Sultānpur Mazra",
  "Krishnanagar",
  "Bārākpur",
  "Bhālswa Jahangirpur",
  "Nāngloi Jāt",
  "Yelahanka",
  "Titāgarh",
  "Dam Dam",
  "Bānsbāria",
  "Madhavaram",
  "Baj Baj",
  "Nerkunram",
  "Kendrāparha",
  "Sijua",
  "Manali",
  "Chakapara",
  "Pāppākurichchi",
  "Herohalli",
  "Madipakkam",
  "Sabalpur",
  "Salua",
  "Balasore",
  "Jālhalli",
  "Chinnasekkadu",
  "Jethuli",
  "Nagtala",
  "Bāgalūr",
  "Pakri",
  "Hunasamaranhalli",
  "Hesarghatta",
  "Bommayapālaiyam",
  "Gundūr",
  "Punādih",
  "Harilādih",
  "Alāwalpur",
  "Mādnāikanhalli",
  "Kādiganahalli",
  "Mahuli",
  "Zeyādah Kot",
  "Arshakunti",
  "Hīrāpur",
  "Mirchi",
  "Sonudih",
  "Sondekoppa",
  "Babura",
  "Mādavar",
  "Kadabgeri",
  "Nanmangalam",
  "Taliganja",
  "Tarchha",
  "Belgharia",
  "Kammanhalli",
  "Sonnappanhalli",
  "Kedihāti",
  "Doddajīvanhalli",
  "Simli Murārpur",
  "Sonāwān",
  "Devanandapur",
  "Tribeni",
  "Huttanhalli",
  "Nathupur",
  "Bāli",
  "Vājarhalli",
  "Saino",
  "Shekhpura",
  "Cāchohalli",
  "Nārāyanpur Kola",
  "Gyan Chak",
  "Kasgatpur",
  "Kitanelli",
  "Harchandi",
  "Santoshpur",
  "Bendravādi",
  "Kodagihalli",
  "Harna Buzurg",
  "Mailanhalli",
  "Sultānpur",
];

export const INDIAN_CITIES_DROPDOWN_OPTIONS = INDIAN_CITIES.map(
  (city, idx) => ({
    id: `${city}_${idx}`,
    label: city,
    value: city,
    selectedLabel: city,
  }),
);
